import { createFileRoute, retainSearchParams, useParams } from "@tanstack/react-router";

import type { RouterContextType } from "@/api/permissions/permissions.api";
import { MODULE_KEYS_MAP } from "@/api/permissions/permissions.types";
import { CloseOutReviewScreen } from "@/components/features/CloseOut/CloseOutReviewScreen";
import { useBreadcrumb } from "@/hooks/useBreadcrumb";
import { authGuardWithPermissions } from "@/utils/authGuard";
import {
  leaveRecordTenant,
  recordTenantSearchSchema,
  syncRecordTenant,
} from "@/utils/recordTenantRoute";
import { getRouteIcon } from "@/utils/getRouteIconComponent";

export const Route = createFileRoute("/_authenticated/close-out/$workOrderId")({
  component: CloseOutReviewRoute,
  validateSearch: recordTenantSearchSchema.parse,
  search: { middlewares: [retainSearchParams(["tenant"])] },
  onEnter: syncRecordTenant,
  onStay: syncRecordTenant,
  onLeave: leaveRecordTenant,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function CloseOutReviewRoute() {
  const { workOrderId } = useParams({ from: "/_authenticated/close-out/$workOrderId" });

  useBreadcrumb([
    {
      title: "Close Out",
      href: "/close-out",
      icon: getRouteIcon(MODULE_KEYS_MAP.closeOut),
    },
  ]);

  return <CloseOutReviewScreen workOrderId={workOrderId} />;
}
